import { useHasAccessToken } from '@/auth/api';
import { useBackend, useBackendMutation } from '@/backend';

export const useMerchantApply = () =>
  useBackendMutation('wealth:post:marketplace/merchant/apply/', {
    revalidate: ['wealth:get:marketplace/merchant/{slug}/'],
  });

export const useMerchant = (userId?: string) => {
  const slug = userId ?? 'me';
  const hasAccessToken = useHasAccessToken();
  return useBackend(
    'wealth:get:marketplace/merchant/{slug}/',
    {
      slug,
    },
    {
      enabled: slug === 'me' ? hasAccessToken : true,
      fetchOptions: {
        retryStatusCodes: [401, 500],
      },
      swrOptions: {
        dedupingInterval: 1000 * 60 * 15,
        refreshInterval: 1000 * 60 * 15,
        onError: () => {},
        keepPreviousData: slug !== 'me',
      },
    },
  );
};

export const useMerchantUpdate = () =>
  useBackendMutation('wealth:put:marketplace/merchant/me/', {
    revalidate: ['wealth:get:marketplace/merchant/{slug}/'],
  });
